import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../commanstyles.module.css";
import { IoMdLock } from "react-icons/io";
import { FaPlusSquare, FaMinusSquare } from "react-icons/fa"; // Import icons
import { IoDocumentTextOutline } from "react-icons/io5"; // Import document icon
import { FiDownload } from "react-icons/fi"; // Import download icon

function CostAuditorComments({ data = [], isSubScribe }) {
    const navigate = useNavigate();
    const [isStandaloneOpen, setIsStandaloneOpen] = useState(false);
    const [isConsolidatedOpen, setIsConsolidatedOpen] = useState(false);
    const [selectedYear, setSelectedYear] = useState("");

    // Extract unique years from the data dynamically
    const years = Array.from(
        new Set(
            data.map((item) => new Date(item.financialYear).getFullYear().toString())
        )
    ).sort();

    // Function to toggle the visibility of the reference documents
    const toggleSection = (section) => {
        if (section === "standalone") {
            setIsStandaloneOpen((prev) => !prev);
        } else if (section === "consolidated") {
            setIsConsolidatedOpen((prev) => !prev);
        }
    };

    const filterReferenceDocuments = (categoryData, year) => {
        return categoryData.filter(
            (item) => new Date(item.financialYear).getFullYear().toString() === year
        );
    };

    const renderTableContent = (categoryData) => {
        const yearStatus = years.map((year) => {
            const yearData = categoryData.find(
                (item) => new Date(item.financialYear).getFullYear().toString() === year
            );

            // Check for the status and return proper value
            return yearData
                ? (yearData.status === "yes" ? "Yes" : yearData.status === "no" ? "No" : "-")
                : "-";
        });

        return (
            <>
                <thead className={styles.tableHeaderRow}>
                    <tr>
                        <th className={styles.tableHeader}>Financial Year</th>
                        {years.map((year) => (
                            <th key={year} className={styles.tableHeader}>
                                {year}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {categoryData.length > 0 ? (
                        <tr className={styles.tableRow}>
                            <td className={styles.tableCell}>
                                Whether Cost Auditors Comments report has been qualified or has any
                                reservations or contains adverse remarks
                            </td>
                            {yearStatus.map((status, index) => (
                                <td key={index} className={styles.tableCell}>
                                    {status}
                                </td>
                            ))}
                        </tr>
                    ) : (
                        <tr>
                            <td
                                colSpan={years.length + 1}
                                className={styles.noDocumentsFound}
                            >
                                Cost Auditors Comments  Not Available
                            </td>
                        </tr>
                    )}
                </tbody>
            </>
        );
    };


    const renderReferenceDocsRow = (categoryData) => {
        const filteredData = selectedYear
            ? filterReferenceDocuments(categoryData, selectedYear)
            : categoryData;

        const referenceDocsForSelectedYear =
            filteredData[0]?.refDoc || null;

        const comments = filteredData[0]?.comments || null;

        return (
            <table style={{ width: "100%" }}>
                <tbody>
                    <tr style={{ backgroundColor: "#F3F5F7" }}>
                        <td style={{ width: "20%", padding: "10px", verticalAlign: "top" }}>Comments</td>
                        <td className={styles.referencedoc_container} style={{ padding: "10px" }}>
                            {comments ? comments : "No comments available"}
                        </td>
                    </tr>
                    <tr style={{ backgroundColor: "#F3F5F7" }}>
                        <td style={{ width: "20%", padding: "10px", verticalAlign: "top" }}>Reference Documents</td>
                        <td className={styles.referencedoc_container} style={{ padding: "10px" }}>
                            {referenceDocsForSelectedYear ? (
                                <>
                                    <div>
                                        {referenceDocsForSelectedYear.MaiinFileName && (
                                            <a
                                                href={referenceDocsForSelectedYear.fileurl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.referencedoc_mainfilename}
                                            >
                                                {referenceDocsForSelectedYear.MaiinFileName}
                                            </a>
                                        )}
                                        <ul style={{ padding: 0 }}>
                                            {referenceDocsForSelectedYear?.Attachments?.map(
                                                (doc, idx) => (
                                                    <li key={idx} className={styles.referencedoc_Attachments}>
                                                        <IoDocumentTextOutline
                                                            size={16}
                                                            style={{
                                                                marginRight: "8px",
                                                                color: "#2961EF",
                                                            }}
                                                        />
                                                        <a
                                                            href={doc.fileurl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                textDecoration: "none",
                                                                color: "#2961EF",
                                                            }}
                                                        >
                                                            {doc.Name}
                                                        </a>
                                                        <button
                                                            onClick={() => {
                                                                const link = document.createElement("a");
                                                                link.href = doc.fileurl;
                                                                link.download = doc.Name;
                                                                link.click();
                                                            }}
                                                            title="Download"
                                                            style={{
                                                                background: "none",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                color: "#2961EF",
                                                                marginLeft: "5px",
                                                                textDecoration: "underline",
                                                            }}
                                                        >
                                                            <FiDownload />
                                                        </button>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                <span>No documents available for selected year</span>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    if (!isSubScribe) {
        return (
            <div className={styles.table_subcontainer}>
                <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
                    <IoMdLock /> Subscription required to view data
                </button>
            </div>
        );
    }

    return (
        <div className={styles.table_subcontainer}>
            {/* Standalone Section */}
            <div style={{ paddingTop: "30px" }}>
                <h3 id={styles.headertext}>Cost Auditors Comments  - Standalone
                </h3>
                {isSubScribe ? (
                    <table className={styles.commantable}>
                        {renderTableContent(
                            data.filter((item) => item.category === "standalone")
                        )}
                    </table>
                ) : null}

                {/* Toggle for reference documents */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div
                        className={styles.highlet_header_content1}
                        role="button"
                        aria-expanded={isStandaloneOpen}
                        aria-controls="financial-data-table"
                        tabIndex={0}
                        onClick={() => toggleSection("standalone")}
                    >
                        <p className={styles.minuse_icon}>
                            {isStandaloneOpen ? (
                                <FaMinusSquare size={22} />
                            ) : (
                                <FaPlusSquare size={22} />
                            )}
                        </p>
                    </div>
                    <h3 className={styles.highlet_text}>
                        DETAILS OF COST AUDITORS  COMMENTS  - STANDALONE
                        {isStandaloneOpen && (
                            <div className={styles.yearSelectContainer}>
                                <select
                                    className={styles.financialYearselect}
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                >
                                    {years.map((year, index) => (
                                        <option key={index} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </h3>
                </div>
                {isStandaloneOpen && (
                    <div>
                        {renderReferenceDocsRow(
                            data.filter((item) => item.category === "standalone")
                        )}
                    </div>
                )}
            </div>

            {/* Consolidated Section */}
            <div style={{ paddingTop: "30px" }}>
                <h3 id={styles.headertext}>Cost Auditors Comments  - Consolidated
                </h3>
                {isSubScribe ? (
                    <table className={styles.commantable}>
                        {renderTableContent(
                            data.filter((item) => item.category === "consolidated")
                        )}
                    </table>
                ) : null}

                {/* Toggle for reference documents */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div
                        className={styles.highlet_header_content1}
                        role="button"
                        aria-expanded={isConsolidatedOpen}
                        aria-controls="financial-data-table"
                        tabIndex={0}
                        onClick={() => toggleSection("consolidated")}
                    >
                        <p className={styles.minuse_icon}>
                            {isConsolidatedOpen ? (
                                <FaMinusSquare size={22} />
                            ) : (
                                <FaPlusSquare size={22} />
                            )}
                        </p>
                    </div>
                    <h3 className={styles.highlet_text}>
                        DETAILS OF COST AUDITORS  COMMENTS - CONSOLIDATED
                        {isConsolidatedOpen && (
                            <div className={styles.yearSelectContainer}>
                                <select
                                    className={styles.financialYearselect}
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                >
                                    {years.map((year, index) => (
                                        <option key={index} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </h3>
                </div>
                {isConsolidatedOpen && (
                    <div>
                        {renderReferenceDocsRow(
                            data.filter((item) => item.category === "consolidated")
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default CostAuditorComments;
